import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import AppProvider from '@/components/providers/app-provider';
import { API_END_POINT, APP_ENV, BRAND_NAME, PASS_URL, SERVICES_URL } from '@/lib/constants';
import '@/styles/globals.css';
import { initCapacitor } from '@/lib/capacitor';

document.title = `${BRAND_NAME} - Espace assuré`;

window.dataLayer = window.dataLayer || [];
window.gmo = window.gmo || {};

window.dataLayer.push({
    environnement: APP_ENV,
});

void initCapacitor();

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    tracesSampleRate: 0.01,
    environment: APP_ENV,
    enabled: true,
    tracePropagationTargets: [PASS_URL, API_END_POINT, SERVICES_URL].filter((target): target is string => !!target),
});

const container = document.getElementById('root');

if (!container) {
    throw new Error('Élément racine introuvable : index.html a-t-il été modifié ?');
}

const root = createRoot(container);

if (APP_ENV) {
    root.render(<AppProvider />);
} else {
    root.render(<h1>.env requis à la racine du projet, un npm start est nécessaire.</h1>);
}
